// Mock data for Connect Legacy demo

export const mockDigitalAssets = [
  {
    id: '1',
    name: 'Family Photos 2025',
    category: 'Photos',
    icon: 'image',
    status: 'stored',
    lastAccessed: '2025-01-15',
    details: { count: '124 photos', size: '420 MB' }
  },
  {
    id: '2',
    name: 'Wedding Video',
    category: 'Videos',
    icon: 'video',
    status: 'stored',
    lastAccessed: '2025-01-14',
    details: { count: '1 video', size: '2.1 GB' }
  },
  {
    id: '3',
    name: 'Letter to My Daughter',
    category: 'Letters',
    icon: 'file-text',
    status: 'stored',
    lastAccessed: '2025-01-16',
    details: { count: '1 letter', size: '4 KB' }
  },
  {
    id: '4',
    name: 'Voice Note for Mom',
    category: 'Voice Messages',
    icon: 'mic',
    status: 'stored',
    lastAccessed: '2025-01-16',
    details: { count: '1 message', size: '8 MB' }
  },
  {
    id: '5',
    name: 'My Life Stories',
    category: 'Memories',
    icon: 'book-open',
    status: 'stored',
    lastAccessed: '2025-01-10',
    details: { count: '12 entries', size: '180 KB' }
  },
  {
    id: '6',
    name: 'Favorite Songs Playlist',
    category: 'Music',
    icon: 'music',
    status: 'stored',
    lastAccessed: '2025-01-15',
    details: { count: '52 songs', size: '320 MB' }
  },
  {
    id: '7',
    name: 'Childhood Album',
    category: 'Photos',
    icon: 'image',
    status: 'stored',
    lastAccessed: '2025-01-16',
    details: { count: '67 photos', size: '210 MB' }
  },
  {
    id: '8',
    name: 'Birthday Video Message',
    category: 'Videos',
    icon: 'video',
    status: 'stored',
    lastAccessed: '2025-01-15',
    details: { count: '1 video', size: '180 MB' }
  }
];

export const mockTrustedContacts = [
  {
    id: '1',
    name: 'Sarah Johnson',
    email: 'sarah.j@email.com',
    relationship: 'Spouse',
    permissions: ['Full Access'],
    verified: true,
    addedDate: '2024-12-01'
  },
  {
    id: '2',
    name: 'Michael Anderson',
    email: 'michael.a@email.com',
    relationship: 'Sibling',
    permissions: ['View Only'],
    verified: true,
    addedDate: '2024-12-05'
  },
  {
    id: '3',
    name: 'Emily Roberts',
    email: 'emily.r@email.com',
    relationship: 'Friend',
    permissions: ['Limited Access'],
    verified: false,
    addedDate: '2025-01-10'
  }
];

export const mockMessages = [
  {
    id: '1',
    recipient: 'Sarah Johnson',
    type: 'written',
    subject: 'My Final Words',
    deliveryType: 'on-trigger',
    status: 'scheduled',
    createdDate: '2024-12-15'
  },
  {
    id: '2',
    recipient: 'Michael Anderson',
    type: 'video',
    subject: 'Birthday Message 2026',
    deliveryType: 'specific-date',
    deliveryDate: '2026-03-15',
    status: 'scheduled',
    createdDate: '2025-01-05'
  },
  {
    id: '3',
    recipient: 'Emily Roberts',
    type: 'voice',
    subject: 'Thank You',
    deliveryType: 'immediate',
    status: 'sent',
    createdDate: '2025-01-10',
    sentDate: '2025-01-10'
  }
];

export const mockMemoryVault = [
  {
    id: '1',
    title: 'Family Photos 2023',
    type: 'photos',
    itemCount: 156,
    size: '2.4 GB',
    uploadDate: '2024-11-20',
    sharedWith: ['Sarah Johnson']
  },
  {
    id: '2',
    title: 'Wedding Video',
    type: 'video',
    itemCount: 1,
    size: '4.8 GB',
    uploadDate: '2024-10-15',
    sharedWith: ['Sarah Johnson', 'Michael Anderson']
  },
  {
    id: '3',
    title: 'Personal Journal',
    type: 'documents',
    itemCount: 47,
    size: '124 MB',
    uploadDate: '2024-12-01',
    sharedWith: []
  }
];

export const mockActivityLog = [
  {
    id: '1',
    action: 'Added new item to folder',
    details: 'Family Photos 2025',
    timestamp: '2025-01-16 14:32',
    type: 'asset'
  },
  {
    id: '2',
    action: 'Updated trusted contact',
    details: 'Sarah Johnson - permissions changed',
    timestamp: '2025-01-15 09:15',
    type: 'contact'
  },
  {
    id: '3',
    action: 'Created new message',
    details: 'Video message for Michael Anderson',
    timestamp: '2025-01-14 16:45',
    type: 'message'
  },
  {
    id: '4',
    action: 'Uploaded to memory vault',
    details: 'Family Photos 2023',
    timestamp: '2025-01-12 11:20',
    type: 'vault'
  },
  {
    id: '5',
    action: 'AI Assistant consultation',
    details: 'Estate planning guidance',
    timestamp: '2025-01-10 13:30',
    type: 'ai'
  }
];

export const mockTriggers = [
  {
    id: '1',
    name: 'Inactivity Trigger',
    type: 'inactivity',
    condition: '90 days no login',
    status: 'active',
    actions: ['Notify contacts', 'Release scheduled messages']
  },
  {
    id: '2',
    name: 'Emergency Trigger',
    type: 'manual',
    condition: 'Manual activation',
    status: 'active',
    actions: ['Grant full access to Sarah Johnson']
  },
  {
    id: '3',
    name: 'Annual Check-in',
    type: 'date-based',
    condition: 'Every January 1st',
    status: 'active',
    actions: ['Send reminder email']
  }
];

export const mockLegalResources = [
  {
    id: '1',
    title: 'Digital Legacy Planning Guide',
    category: 'Guides',
    description: 'Complete guide to planning your digital legacy',
    readTime: '10 min'
  },
  {
    id: '2',
    title: 'Understanding Digital Inheritance Laws',
    category: 'Legal',
    description: 'State-by-state legal overview for personal digital content',
    readTime: '15 min'
  },
  {
    id: '3',
    title: 'Protecting Your Memories Online',
    category: 'Security',
    description: 'How to safely store and share photos, videos, and messages',
    readTime: '8 min'
  },
  {
    id: '4',
    title: 'Preserving Voice & Video Messages',
    category: 'Guides',
    description: 'Best practices for recording and storing meaningful messages',
    readTime: '12 min'
  }
];

export const features = [
  {
    title: 'Your Personal Folder',
    description: 'Store videos, photos, voice messages, letters, and documents in one secure place.',
    icon: 'database'
  },
  {
    title: 'Smart Messaging',
    description: 'Send messages to loved ones instantly or schedule them for specific dates or life events.',
    icon: 'message-circle'
  },
  {
    title: 'Trusted Contacts',
    description: 'Designate family and friends who can access your digital legacy with customizable permissions.',
    icon: 'users'
  },
  {
    title: 'Memory Vault',
    description: 'Store precious photos, videos, and documents to be shared with future generations.',
    icon: 'heart'
  },
  {
    title: 'AI Assistant',
    description: 'Get personalized guidance on preserving memories, planning your digital legacy, and more.',
    icon: 'sparkles'
  },
  {
    title: 'Automated Triggers',
    description: 'Set up smart triggers based on inactivity, dates, or manual activation to share your legacy.',
    icon: 'zap'
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Create Your Folder',
    description: 'Sign up and set up your personal Connect Legacy folder in minutes.'
  },
  {
    step: 2,
    title: 'Add Your Memories',
    description: 'Upload photos, videos, voice notes, and written messages you want to preserve.'
  },
  {
    step: 3,
    title: 'Choose Your Contacts',
    description: 'Select trusted individuals and set their access permissions.'
  },
  {
    step: 4,
    title: 'Set Your Triggers',
    description: 'Configure when and how your memories should be shared.'
  }
];

export const quizQuestions = [
  {
    id: 1,
    question: "How many photos and videos do you have stored online?",
    options: [
      { text: "None", score: 0 },
      { text: "Less than 100", score: 1 },
      { text: "100-1,000", score: 2 },
      { text: "1,000-10,000", score: 3 },
      { text: "More than 10,000", score: 4 }
    ]
  },
  {
    id: 2,
    question: "Do you have important voice notes or video messages saved?",
    options: [
      { text: "No", score: 1 },
      { text: "A few", score: 2 },
      { text: "Quite a lot", score: 3 },
      { text: "Many — they're important to me", score: 4 }
    ]
  },
  {
    id: 3,
    question: "Have you written down meaningful messages for loved ones?",
    options: [
      { text: "Not at all", score: 4 },
      { text: "Thought about it", score: 3 },
      { text: "Started but not finished", score: 2 },
      { text: "Yes, all saved safely", score: 1 }
    ]
  },
  {
    id: 4,
    question: "Does anyone know where your important memories are stored?",
    options: [
      { text: "No one", score: 4 },
      { text: "Maybe one person", score: 3 },
      { text: "A few people know some", score: 2 },
      { text: "Everything is documented", score: 1 }
    ]
  },
  {
    id: 5,
    question: "What happens to your personal photos and messages if something happens to you?",
    options: [
      { text: "I have no idea", score: 4 },
      { text: "I've thought about it", score: 3 },
      { text: "I have some preferences", score: 2 },
      { text: "I have clear instructions", score: 1 }
    ]
  }
];

export const quizResults = {
  low: {
    range: [5, 10],
    title: "You're Well Prepared! 🎉",
    description: "You have a good handle on your digital legacy, but Connect Legacy can help you take it to the next level with automated systems and secure storage.",
    recommendation: "Consider using Connect Legacy to centralize and automate your digital legacy."
  },
  medium: {
    range: [11, 16],
    title: "You Need a Plan 📋",
    description: "You're aware of digital legacy issues, but there's work to be done. Your loved ones might struggle to access important memories and messages.",
    recommendation: "Connect Legacy can help you organize everything in one secure place with clear instructions for your loved ones."
  },
  high: {
    range: [17, 20],
    title: "Urgent Action Required! ⚠️",
    description: "Your digital legacy is at serious risk. Without proper planning, your family could lose access to precious photos, videos, and important messages.",
    recommendation: "Start with Connect Legacy today to protect what matters most. Our platform makes it simple to preserve your memories."
  }
};

export const teamMembers = [
  {
    name: "Jiya Sheth",
    role: "Co-Founder",
    bio: "Jiya envisions a world where no family struggles with digital inheritance. Leading product development at Connect Legacy, she's on a mission to give everyone a peaceful digital goodbye. Her passion lies in building technology that protects what matters most—turning complexity into clarity for families when they need it most.",
    image: "/assets/team/jiya.png"
  },
  {
    name: "Raisa Rahmat",
    role: "Co-Founder",
    bio: "A 20-year-old visionary from Indonesia with an MSc in International Business from Bayes Business School. Raisa's diverse experience across banking, NGOs, and financial cooperatives gives her unique insight into how digital assets shape modern lives. She architects Connect Legacy's operational backbone, ensuring every system runs with precision and care.",
    image: "/assets/team/raisa.jpeg"
  }
];

// Folders shown in "My Folder" section
export const myFolders = [
  {
    id: 'japan-memories',
    name: 'Japan Memories',
    description: 'Trips, photos, and stories from Japan',
    itemCount: 42,
    color: 'bg-pink-100',
    iconColor: 'text-pink-600',
    isEmpty: false
  },
  {
    id: 'my-daughter',
    name: 'My Daughter',
    description: 'Photos, videos, and letters for her',
    itemCount: 87,
    color: 'bg-purple-100',
    iconColor: 'text-purple-600',
    isEmpty: false
  },
  {
    id: 'family-recipes',
    name: 'Family Recipes',
    description: 'Grandma\'s handwritten cookbook',
    itemCount: 23,
    color: 'bg-amber-100',
    iconColor: 'text-amber-600',
    isEmpty: false
  },
  {
    id: 'voice-letters',
    name: 'Voice Letters',
    description: 'Audio messages for loved ones',
    itemCount: 12,
    color: 'bg-blue-100',
    iconColor: 'text-blue-600',
    isEmpty: false
  },
  {
    id: 'empty-folder',
    name: 'New Folder',
    description: 'Empty — click to add memories',
    itemCount: 0,
    color: 'bg-gray-100',
    iconColor: 'text-gray-500',
    isEmpty: true
  }
];

// Options for "What would you like to store?" survey
export const folderStorageOptions = [
  { id: 'photos', label: 'Photos', icon: 'image' },
  { id: 'videos', label: 'Videos', icon: 'video' },
  { id: 'voice', label: 'Voice Messages', icon: 'mic' },
  { id: 'letters', label: 'Written Letters', icon: 'file-text' },
  { id: 'documents', label: 'Personal Documents', icon: 'file' },
  { id: 'music', label: 'Music & Playlists', icon: 'music' },
  { id: 'memories', label: 'Life Stories & Memories', icon: 'book-open' },
  { id: 'recipes', label: 'Family Recipes', icon: 'utensils' },
  { id: 'journal', label: 'Personal Journals', icon: 'notebook' },
  { id: 'art', label: 'Art & Drawings', icon: 'palette' }
];
